import type {
  ModelDetail,
  ModelRecord,
  ModelResource,
  ProjectDetail,
  ProjectRecord,
} from "@/lib/api/workspace/types";

export const PROJECT_TAB_VALUES = ["models", "draft-models", "applications"] as const;
export type ProjectTab = (typeof PROJECT_TAB_VALUES)[number];

export const MODEL_TAB_VALUES = [
  "schema",
  "artifacts",
  "baselines",
  "datasets",
  "custom-metrics",
  "segments",
] as const;
export type ModelTab = (typeof MODEL_TAB_VALUES)[number];

export const SCHEMA_COLUMN_GROUP_VALUES = [
  "inputs",
  "outputs",
  "targets",
  "metadata",
  "custom-features",
] as const;
export type SchemaColumnGroup = (typeof SCHEMA_COLUMN_GROUP_VALUES)[number];

export const MODEL_TASK_TYPE_VALUES = [
  "not-set",
  "regression",
  "binary-classification",
  "multi-class-classification",
] as const;
export type ModelTaskType = (typeof MODEL_TASK_TYPE_VALUES)[number];

export type Project = ProjectRecord;
export type ProjectWithDetails = ProjectDetail;
export type ProjectModel = ModelRecord;
export type ProjectModelDetail = ModelDetail;
export type ProjectModelResource = ModelResource;

export interface ModelSchemaColumn {
  id: string;
  name: string;
  dataType: string;
  role: SchemaColumnGroup;
}

export function getSchemaColumns(
  model: ProjectModelDetail,
  group: SchemaColumnGroup,
): readonly ModelSchemaColumn[] {
  const schemaResource = model.resources.find(
    (resource) => resource.resourceType === "schema",
  );
  const columns = schemaResource?.data.columns;
  if (!Array.isArray(columns)) return [];

  return columns.flatMap((entry, index) => {
    if (typeof entry !== "object" || entry === null) return [];
    const value = entry as Record<string, unknown>;
    const name = typeof value.name === "string" ? value.name : "";
    const role = typeof value.role === "string" ? value.role : "metadata";
    if (!name || role !== group) return [];

    return [
      {
        id: typeof value.id === "string" ? value.id : `${group}-${index}`,
        name,
        dataType: typeof value.dataType === "string" ? value.dataType : "unknown",
        role: group,
      },
    ];
  });
}
